export class ClientLink {
  clientLinkId!: number;
  title!: string;
  link!: boolean;
  clientGuid!: string;
  constructor(source: Partial<ClientLink>) {
    Object.assign(this, source);
  }
}
